/** localStorage keys for MarketingCornerPopoverStack — cleared on sign-out for this user. */
const PREFIX = 'bcc:eventCorner:autoDismissed:v1:';

export function eventCornerDismissStorageKey(userId: string, eventId: string): string {
  return `${PREFIX}${userId}:${eventId}`;
}

export function clearEventCornerDismissStateForUser(userId: string): void {
  const needle = `${PREFIX}${userId}:`;
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k?.startsWith(needle)) localStorage.removeItem(k);
    }
  } catch {
    /* quota / private mode */
  }
}
